<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-lg-4">
              <div class="card-header pb-0">
                <h6>Riwayat Pembayaran Vendor</h6>
              </div>
            </div>
            <div class="col-lg-5">
              <input type="text" class="form-control mt-3" placeholder="Search by PO No." v-model="search.po_no" v-on:keyup.enter="quickSearch()">
            </div>
            <div class="col-lg-3">
              <argon-button style="margin-left: 60px;" class="mt-4" variant="gradient" color="secondary" size="sm" @click="formFilter.show = true"><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2 mt-4">
            <div class="table-responsive p-0 scroll">
              <table class="table table-striped align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Tanggal Bayar</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">PO No.</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Vendor</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Termin</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Jumlah</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Metode</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">No. Referensi</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Catatan</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Dicatat Oleh</th>
                    <th class="text-secondary"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in table.data" :key="i">
                    <td class="align-middle text-center"><span class="text-secondary text-xs font-weight-bold">{{ moment(row.payment_date).locale('id').format('LL') }}</span></td>
                    <td class="align-middle text-center"><span class="badge badge-sm bg-gradient-primary">{{ row.po_no }}</span></td>
                    <td class="align-middle text-center"><span class="text-secondary text-xs font-weight-bold">{{ row.company_name }}</span></td>
                    <td class="align-middle text-center"><span class="text-secondary text-xs font-weight-bold">{{ row.term_payment ? row.term_payment+' ('+row.percentage+'%)' : '-' }}</span></td>
                    <td class="align-middle text-end"><span class="text-secondary text-xs font-weight-bold">{{ fmt(row.payment_amount, row.currency) }}</span></td>
                    <td class="align-middle text-center"><span class="text-secondary text-xs font-weight-bold">{{ row.payment_method }}</span></td>
                    <td class="align-middle text-center"><span class="text-secondary text-xs font-weight-bold">{{ row.reference_no }}</span></td>
                    <td class="align-middle text-center"><span class="text-secondary text-xs font-weight-bold">{{ row.note }}</span></td>
                    <td class="align-middle text-center"><span class="text-secondary text-xs font-weight-bold">{{ row.created_by }}</span></td>
                    <td><i class="fa fa-undo fa-sm" aria-hidden="true" title="Batalkan pembayaran ini (koreksi salah input)" style="cursor: pointer; margin-right: 20px;" @click="remove(row)"></i></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card-footer">
            <div class="float-left">TOTAL ROWS : {{ table.data.length }}</div>
            <div class="float-right">
              <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL FILTER ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <div class="row">
        <div class="col-11 float-left"><span class="modal__title">Filter</span></div>
        <div class="col-1 float-right"><i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i></div>
      </div><hr>
      <div class="modal__content container">
        <label class="form-control-label mt-3">Vendor</label>
        <input type="text" class="form-control" placeholder="Nama Vendor" v-model="search.vendor_name">
        <label class="form-control-label mt-3">Metode</label>
        <select class="form-select" v-model="search.payment_method">
          <option value="">All</option>
          <option v-for="(m, i) in paymentMethods" :key="i" :value="m">{{ m }}</option>
        </select>
        <label class="form-control-label mt-3">Tanggal Bayar</label>
        <flat-pickr :config="{ mode: 'range',}" class="form-control" v-model="search.payment_date"/>
      </div>
      <div class="row float-right mt-3">
        <div class="col-6"></div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button variant="gradient" color="secondary" size="sm" width="1" @click="search = {po_no: '', vendor_name: '', payment_method: '', payment_date: ''}">Clear</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="quickSearch()">Filter</argon-button>
        </div>
      </div>
    </vue-final-modal>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import BasePagination from "@/components/BasePagination";
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
var moment = require('moment');
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import accounting from '@/services/accounting/accounting.service';

export default {
  name: "AccPaymentHistory",
  components: {
    ArgonButton,
    VueFinalModal,
    BasePagination,
    flatPickr,
  },
  data() {
    return {
      moment: moment,
      pagination: { page_count: '', page: 1 },
      table: { data: [] },
      formFilter: { show: false },
      paymentMethods: ['Transfer', 'Cash', 'Giro', 'Cek', 'Procurement Payment'],
      search: { po_no: '', vendor_name: '', payment_method: '', payment_date: '' },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    fmt(value, currency) {
      return (currency || 'IDR')+' '+Number(value || 0).toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    get() {
      let context = this;
      Api(context, accounting.paymentHistory({ po_no: context.search.po_no, vendor_name: context.search.vendor_name, payment_method: context.search.payment_method, payment_date: context.search.payment_date, page: context.pagination.page })).onSuccess(function(response) {
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page;
      }).onError(function() {
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() {
          context.formFilter.show = false;
      })
      .call()
    },
    quickSearch() {
      this.pagination.page = 1;
      this.get();
    },
    remove(row) {
      if (!confirm('Batalkan pembayaran '+this.fmt(row.payment_amount, row.currency)+' untuk '+row.po_no+'? Status termin & hutang akan dihitung ulang.')) {
        return;
      }
      let context = this;
      Api(context, accounting.deletePayment(row.id)).onSuccess(function() {
          context.notify('Pembayaran Dibatalkan', 'success')
          context.get();
      }).onError(function() {
          context.notify('Gagal Membatalkan Pembayaran', 'error')
      })
      .call();
    },
    changePage(page) {
      this.pagination.page = page;
      this.get();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 2000 });
      } else {
        toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 3000 });
      }
    },
  }
};
</script>

<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
.scroll {
  overflow: auto;
  height: 600px;
}
.scroll thead th {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #F0F8FF;
}
</style>
